var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7016 20.7015C21.1897 20.2134 21.1897 19.4219 20.7016 18.9338L13.8016 12.0338L20.7015 5.13389C21.1897 4.64573 21.1897 3.85427 20.7015 3.36612C20.2134 2.87796 19.4219 2.87796 18.9338 3.36612L12.0338 10.2661L5.1339 3.36612C4.64575 2.87796 3.85429 2.87796 3.36614 3.36612C2.87798 3.85427 2.87798 4.64573 3.36614 5.13388L10.2661 12.0338L3.36612 18.9338C2.87796 19.4219 2.87796 20.2134 3.36612 20.7016C3.85427 21.1897 4.64573 21.1897 5.13388 20.7015L12.0338 13.8016L18.9338 20.7015C19.422 21.1897 20.2134 21.1897 20.7016 20.7015Z",
    fill: "#002D72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.9b23881a2f289c5f77333b6b56a21dfc.svg";
export { ForwardRef as ReactComponent };